export const BookingQuestionsMappingKeys = {
    customerId: 'CustomerId',
    customerName: 'CustomerName',
    customerPhone: 'CustomerPhone'
}